import './index.css';
import App from './App';
import React from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom/client';
import { store, persistor } from './store';
import { PersistGate } from 'redux-persist/integration/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { initMixpanel } from './lib/mixpanel';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      gcTime: 1000 * 60 * 24,
      retry: 1,
      refetchOnMount: true,
    },
  },
});

const token = import.meta.env.VITE_MIXPANEL_TOKEN;
const enableAnalytics = import.meta.env.VITE_ENABLE_ANALYTICS === 'true';

// Initialize only when token present AND analytics enabled (or after user consents)
if (token && enableAnalytics) {
  initMixpanel(token);
}

const root = document.getElementById('app');

if (!root) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate
        loading={<div className="loader"></div>}
        persistor={persistor}
      >
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
